import { BoardTypes, UPDATE_FIELD } from '../types';

const boardReducer = (
    state = [
        [
            { char: 'F', player: 1 },
            { char: 'B', player: 1 },
            { char: '1', player: 1 },
            { char: '2', player: 1 },
            { char: '3', player: 1 },
            { char: '2', player: 1 },
        ],
        [
            { char: '10', player: 1 },
            { char: '8', player: 1 },
            { char: '6', player: 1 },
            { char: '3', player: 1 },
            { char: '4', player: 1 },
            { char: '2', player: 1 },
        ],
        [
            { char: '0', player: 0 },
            { char: '0', player: 0 },
            { char: '0', player: 0 },
            { char: '0', player: 0 },
            { char: '0', player: 0 },
            { char: '0', player: 0 },
        ],
        [
            { char: '0', player: 0 },
            { char: '0', player: 0 },
            { char: '0', player: 0 },
            { char: '0', player: 0 },
            { char: '0', player: 0 },
            { char: '0', player: 0 },
        ],
        [
            { char: '0', player: 0 },
            { char: '0', player: 0 },
            { char: '0', player: 0 },
            { char: '0', player: 0 },
            { char: '0', player: 0 },
            { char: '0', player: 0 },
        ],
        [
            { char: '0', player: 0 },
            { char: '0', player: 0 },
            { char: '0', player: 0 },
            { char: '0', player: 0 },
            { char: '0', player: 0 },
            { char: '0', player: 0 },
        ],
    ],
    action: BoardTypes
) => {
    switch (action.type) {
        case 'ADD_TO_BOARD':
            return action.newBoard;
        case UPDATE_FIELD:
            state[action.col][action.row] = {
                char: action.char,
                player: action.player,
            };
            return state;
        default:
            return state;
    }
};

export default boardReducer;
